import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'
import AuthService from './services/AuthService'

Vue.use(VueRouter);

// 1. Define route components.
// These can be imported from other files
import HttpErrorView from './components/Views/HttpErrorView'
import HomeView from './components/Views/HomeView.vue'
import SearchIndexView from './components/Views/Search/SearchIndexView.vue'
import SendEmailView from './components/Views/Search/SendEmailView.vue'
import LoginView from './components/Views/Auth/LoginView.vue'
import ForgotPasswordView from './components/Views/Auth/ForgotPasswordView.vue'
import ForgotPasswordResetView from './components/Views/Auth/ForgotPasswordResetView.vue'
import RegisterView from './components/Views/Auth/RegisterView.vue'
import PendingAuthorisation from './components/Views/Auth/PendingAuthorization.vue'
import RanksIndexView from './components/Views/Ranks/IndexRanksView.vue'
import RankCreateView from './components/Views/Ranks/CreateRankView.vue'
import RankDeleteView from './components/Views/Ranks/DeleteRankView.vue'
import ForcesIndexView from './components/Views/Forces/IndexForcesView.vue'
import ForceCreateView from './components/Views/Forces/CreateForceView.vue'
import ForceDeleteView from './components/Views/Forces/DeleteForceView.vue'
import LPAsIndexView from './components/Views/LPAs/IndexLPAsView.vue'
import LPACreateView from './components/Views/LPAs/CreateLPAView.vue'
import LPADeleteView from './components/Views/LPAs/DeleteLPAView.vue'
import NeighbourhoodsIndexView from './components/Views/Neighbourhoods/IndexNeighbourhoodsView.vue'
import NeighbourhoodCreateView from './components/Views/Neighbourhoods/CreateNeighbourhoodView.vue'
import NeighbourhoodDeleteView from './components/Views/Neighbourhoods/DeleteNeighbourhoodView.vue'
import VisitFrequencyCreateView from './components/Views/VisitFrequency/CreateVisitFrequencyView.vue'
import UsersIndexView from './components/Views/Users/IndexUsersView.vue'
import UpdateUserView from './components/Views/Users/UpdateUserView.vue'
import ChangePasswordView from './components/Views/Users/ChangePasswordView.vue'
import ProductCategoriesIndexView from './components/Views/ProductCategories/IndexProductCategoriesView.vue'
import ProductCategoryCreateView from './components/Views/ProductCategories/CreateProductCategoryView.vue'
import ProductCategoryDeleteView from './components/Views/ProductCategories/DeleteProductCategoryView.vue'
import EmailTemplateCreateView from './components/Views/EmailTemplate/CreateEmailTemplateView.vue'
import RetailersIndexView from './components/Views/Retailers/IndexRetailersView.vue'
import RetailerCreateView from './components/Views/Retailers/CreateRetailerView.vue'
import RetailerDeleteView from './components/Views/Retailers/DeleteRetailerView.vue'
import RetailerDetailsView from './components/Views/Retailers/ViewRetailerView.vue'
import RetailerVisitCreateView from './components/Views/RetailerVisits/CreateRetailerVisitView.vue'
import RetailerVisitDeleteView from './components/Views/RetailerVisits/DeleteRetailerVisitView.vue'
import ViewRetailerHistoryView from './components/Views/RetailerHistory/ViewRetailerHistoryView.vue'
// 2. Define some routes
// Each route should map to a component. The "component" can
const routes = [
    { 
        path: '/', 
        component: HomeView, 
        name:'home',
    },
    {
        path: '/login', 
        component: LoginView, 
        name:'login',
    },
    {
        path: '/register', 
        component: RegisterView, 
        name:'register',
    },
    {
        path: '/password/reset',
        component: ForgotPasswordView,
        name: 'password.request'
    },
    {
        path: '/password/reset/:token',
        component: ForgotPasswordResetView,
        name: 'password.reset'
    },
    {
        path: '/search',
        component: SearchIndexView,
        name: 'search.index',
        meta: { permission: 'user' }
    },
    {
        path: '/search/email',
        component: SendEmailView,
        name: 'search.email',
        meta: { permission: 'user' }
    },
    {
        path: '/ranks', 
        component: RanksIndexView, 
        name:'ranks.index',
        meta: { permission: 'edit-ranks' }
    },
    {
        path: '/ranks/create', 
        component: RankCreateView, 
        name:'ranks.create',
        meta: { permission: 'edit-ranks' }
    },
    {
        path: '/ranks/edit/:id', 
        component: RankCreateView, 
        name:'ranks.edit',
        props: true,
        meta: { permission: 'edit-ranks' }
    },
    {
        path: '/ranks/delete/:id', 
        component: RankDeleteView, 
        name:'ranks.delete',
        props: true,
        meta: { permission: 'edit-ranks' }
    },
    {
        path: '/forces', 
        component: ForcesIndexView, 
        name:'forces.index',
        meta: { permission: 'edit-forces' }
    },
    {
        path: '/forces/create', 
        component: ForceCreateView, 
        name:'forces.create',
        meta: { permission: 'edit-forces' }
    },
    {
        path: '/forces/edit/:id', 
        component: ForceCreateView, 
        name:'forces.edit',
        props: true,
        meta: { permission: 'edit-forces' }
    },
    {
        path: '/forces/delete/:id', 
        component: ForceDeleteView, 
        name:'forces.delete',
        props: true,
        meta: { permission: 'edit-forces' }
    },
    {
        path: '/lpas', 
        component: LPAsIndexView, 
        name:'lpas.index',
        meta: { permission: 'edit-lpas' }
    },
    {
        path: '/lpas/create', 
        component: LPACreateView, 
        name:'lpas.create',
        meta: { permission: 'edit-lpas' }
    },
    {
        path: '/lpas/edit/:id', 
        component: LPACreateView, 
        name:'lpas.edit',
        props: true,
        meta: { permission: 'edit-lpas' }
    },
    {
        path: '/lpas/delete/:id', 
        component: LPADeleteView, 
        name:'lpas.delete',
        props: true,
        meta: { permission: 'edit-lpas' }
    },
    {
        path: '/neighbourhoods', 
        component: NeighbourhoodsIndexView, 
        name:'neighbourhoods.index',
        meta: { permission: 'edit-neighbourhoods' }
    },
    {
        path: '/neighbourhoods/create', 
        component: NeighbourhoodCreateView, 
        name:'neighbourhoods.create',
        meta: { permission: 'edit-neighbourhoods' }
    },
    {
        path: '/neighbourhoods/edit/:id', 
        component: NeighbourhoodCreateView, 
        name:'neighbourhoods.edit',
        props: true,
        meta: { permission: 'edit-neighbourhoods' }
    },
    {
        path: '/neighbourhoods/delete/:id', 
        component: NeighbourhoodDeleteView, 
        name:'neighbourhoods.delete',
        props: true,
        meta: { permission: 'edit-neighbourhoods' }
    },
    {
        path: '/edit-visit-frequency', 
        component: VisitFrequencyCreateView, 
        name:'visitFrequency.edit',
        meta: { permission: 'edit-visit-frequency' }
    },
    {
        path: '/users', 
        component: UsersIndexView, 
        name:'users.index',
        meta: { permission: 'edit-users' }
    },
    {
        path: '/users/edit/:id', 
        component: UpdateUserView, 
        name:'users.edit',
        props: true,
        meta: { permission: 'edit-users' }
    },
    {
        path: '/profile', 
        component: UpdateUserView, 
        name:'profile',
        props: true,
        meta: { permission: 'edit-profile' }
    },
    {
        path: '/change-password',
        name:'password.change',
        component: ChangePasswordView,
        meta: { permission: 'edit-profile'}
    },
    {
        path: '/product-categories', 
        component: ProductCategoriesIndexView, 
        name:'productCategories.index',
        meta: { permission: 'edit-product-categories' }
    },
    {
        path: '/product-categories/create', 
        component: ProductCategoryCreateView, 
        name:'productCategories.create',
        meta: { permission: 'edit-product-categories' }
    },
    {
        path: '/product-categories/edit/:id', 
        component: ProductCategoryCreateView, 
        name:'productCategories.edit',
        props: true,
        meta: { permission: 'edit-product-categories' }
    },
    {
        path: '/product-categories/delete/:id', 
        component: ProductCategoryDeleteView, 
        name:'productCategories.delete',
        props: true,
        meta: { permission: 'edit-product-categories' }
    },
    {
        path: '/edit-email-template', 
        component: EmailTemplateCreateView, 
        name:'emailTemplate.edit',
        props: true,
        meta: { permission: 'edit-email-templates' }
    },
    {
        path: '/retailers', 
        component: RetailersIndexView, 
        name:'retailers.index',
        meta: { permission: 'list-retailers' }
    },
    {
        path: '/retailers/view/:id', 
        component: RetailerDetailsView, 
        name:'retailers.details',
        props: true,
        meta: { permission: 'view-retailers' }
    },
    {
        path: '/retailers/:retailerId/visits/edit/:id',
        component: RetailerVisitCreateView,
        name: 'visits.edit',
        props: true,
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/retailers/:retailerId/visits/create',
        component: RetailerVisitCreateView,
        name: 'visits.create',
        props: true,
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/retailers/:retailerId/visits/delete/:id',
        component: RetailerVisitDeleteView,
        name: 'visits.delete',
        props: true,
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/retailers/create', 
        component: RetailerCreateView, 
        name:'retailers.create',
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/retailers/edit/:id', 
        component: RetailerCreateView, 
        name:'retailers.edit',
        props: true,
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/retailers/delete/:id', 
        component: RetailerDeleteView, 
        name:'retailers.delete',
        props: true,
        meta: { permission: 'delete-retailers' }
    },
    {
        path: '/retailers/:retailerId/history/view/:id',
        component: ViewRetailerHistoryView,
        name: 'history.view',
        props: true,
        meta: { permission: 'edit-retailers' }
    },
    {
        path: '/oops',
		component: HttpErrorView,
        name: 'error',
        props: true
    },
    {
        path: '/pending-authorisation',
		component: PendingAuthorisation,
        name: 'auth.pending',
	},
    {
        path: '*',
        component: HttpErrorView,
        name: 'HttpError',
    }
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    let permission = to.meta.permission || '';
    
    document.title = 'We Don\'t Buy Crime';

    if (store.state.sessionLoaded) {
        // the route requires a permission and no user is logged in.
        if (permission !== '' && ! store.state.loggedIn ) {
            return next({name:'login'});
        }

        // this route requires permission, check if user has permission.
        if (permission && !store.state.currentUser.can(permission)) {
            return next({name:'error', params:{code:403, msg:"Forbidden"}});
        }
        
        return next();
    }
  
    AuthService.session()
        .then(({data}) => {
            if (data.logged_in_user !== null) {
                store.commit('login', data);
            } else {
                store.commit('logout');
            }

            // the route requires a permission and no user is logged in.
            if (permission !== '' && ! store.state.loggedIn ) {
                return next({name:'login'});
            }

            // this route requires permission, check if user has permission.
            if (permission && !store.state.currentUser.can(permission)) {
                return next({name:'error', params:{code:403, msg:"Forbidden"}});
            }
            
            return next();
        });
    
});

export default router;